import { headerCellRenderer, textCellRenderer } from './cellRenderers';
export var GridColumn = function () { return null; };
GridColumn.defaultProps = {
    headerCell: headerCellRenderer,
    cell: textCellRenderer,
    hidden: false
};
//# sourceMappingURL=GridColumn.js.map